/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Chat } from './Chat';
import {
    ChatFromJSON,
    ChatFromJSONTyped,
    ChatToJSON,
    ChatToJSONTyped,
} from './Chat';

/**
 * 
 * @export
 * @interface PaginatedChatList
 */
export interface PaginatedChatList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedChatList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedChatList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedChatList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Chat>}
     * @memberof PaginatedChatList
     */
    results: Array<Chat>;
}

/**
 * Check if a given object implements the PaginatedChatList interface.
 */
export function instanceOfPaginatedChatList(value: object): value is PaginatedChatList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedChatListFromJSON(json: any): PaginatedChatList {
    return PaginatedChatListFromJSONTyped(json, false);
}

export function PaginatedChatListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedChatList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ChatFromJSON)),
    };
}

  export function PaginatedChatListToJSON(json: any): PaginatedChatList {
      return PaginatedChatListToJSONTyped(json, false);
  }

  export function PaginatedChatListToJSONTyped(value?: PaginatedChatList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(ChatToJSON)),
    };
}

